import CardTitle from '@/ui/title/Title';
import Card from '@/ui/card/defaultCard/Card';
import TopNews from '@/components/newsPage/components/mainNews/components/topNews/TopNews';
import Preloaer from '@/ui/preloaders/componentPreloader/ComponentPreloader';
import { useTranslation } from 'react-i18next';
import Nodata from '@/ui/errorSigns/noData/Nodata';
import { useNavigate } from 'react-router-dom';

interface HomeNewsProps {
  data?: any;
  isLoading?: boolean;
}

const HomeNews = ({ data, isLoading }: HomeNewsProps) => {
  const [t] = useTranslation('news');
  const [dT] = useTranslation('noData');
  const navigate = useNavigate();

  return (
    <Card>
      <CardTitle
        title={t('Main News')}
        desc={t('Highlighting major ESG news from the last day.')}
        more={t('More News')}
        onClick={() => navigate('/news')}
      />
      {isLoading ? (
        <Preloaer width="1174px" height="710.5px" />
      ) : (
        <>
          {data?.length > 0 ? (
            <div>
              <TopNews articles={data} />
            </div>
          ) : (
            <Nodata desc={dT('No ESG news.')} className="h-[200px]" />
          )}
        </>
      )}
    </Card>
  );
};

export default HomeNews;
